import {FunctionComponent, useEffect, useRef} from 'react'
import {checkIsExternal, checkIsFile, scrollToHash} from './link'

import {styler} from './style'
import {useRouter} from 'next/navigation'

const click = (router, e) => {
	const href = e.currentTarget.getAttribute('href')

	if (
		e.defaultPrevented ||
		e.button !== 0 ||
		e.altKey ||
		e.metaKey ||
		e.ctrlKey ||
		e.shiftKey ||
		e.currentTarget.target === '_blank' ||
		checkIsExternal(href) ||
		e.target.protocol === 'mailto:'
	) {
		return
	}

	e.preventDefault()
	if (href.substring(0, 1) === '#') {
		scrollToHash(href)
	} else {
		router.push(href)
	}
}

const removeQueryParams = (url) =>
	url.indexOf('?') > 0 ? url.substring(0, url.indexOf('?')) : url

const styles = styler('trusted')

export const Trusted: FunctionComponent<{
	children: string
	className?: string
}> = ({children, ...props}) => {
	const router = useRouter()
	const dom = useRef<HTMLDivElement>(undefined)

	useEffect(() => {
		const clear = []
		const listener = click.bind(router)
		dom.current.querySelectorAll('a').forEach((link) => {
			const href = link.getAttribute('href')
			if (!href) return
			const hrefWithoutQuery = removeQueryParams(href)
			if (checkIsFile(hrefWithoutQuery) || checkIsExternal(href)) {
				link.setAttribute('target', '_blank')
				link.setAttribute('rel', 'noopener')
			} else if (!link.getAttribute('target')) {
				link.setAttribute('target', '_self')
				link.addEventListener('click', (e) => click(router, e))
			}
			clear.push(() => link.removeEventListener('click', listener))
		})

		dom.current.querySelectorAll('table').forEach((table) => {
			const wrapper = document.createElement('div')
			wrapper.classList.add('wysiwyg-table')
			table.replaceWith(wrapper)
			wrapper.appendChild(table)
		})

		return () => {
			clear.forEach((f) => f())
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<div
			ref={dom}
			className={styles().mergeProps(props)}
			dangerouslySetInnerHTML={{
				__html: Array.isArray(children) ? children[0] : children
			}}
		/>
	)
}
